import * as React from 'react';
import {JSSClassesProps} from 'react-jss';
import {Room} from '../../../models/hotel-room-types';
import {ComponentJSSClasses} from './styles';
import {RoomCard} from './RoomCard';
import Button from 'sletat-ui-components2/dist/components/Button';
import {HotelRoomsAdaptiveType} from '../../../models/adaptive';
import {IconArrowBottom} from '../../../../components/icons/IconArrowBottom';
import classNames from 'classnames';

export interface HotelRoomsProps {
    rooms: Array<Room>;
    adaptiveType: HotelRoomsAdaptiveType;
}

interface StyledHotelRoomsProps
    extends HotelRoomsProps,
        JSSClassesProps<ComponentJSSClasses> {
}

export const HotelRooms = ({rooms, classes, adaptiveType}: StyledHotelRoomsProps) => {
    const [isHidden, setIsHidden] = React.useState(true);
    let roomReviewCount = adaptiveType === HotelRoomsAdaptiveType.Tablet768_960 ? 2 : 3;

    if (!rooms.length) return null;

    return (
        <section className={classes.container}>
            <h2 className={classes.header}>Номерной фонд</h2>
            <div className={classes.wrapper}>
                {(isHidden ? rooms.slice(0, roomReviewCount) : rooms).map((room) => {
                    return (
                        <React.Fragment key={`${room.id}_rooItem`}>
                            <RoomCard room={room} />
                        </React.Fragment>
                    );
                })}
            </div>
            {rooms.length > roomReviewCount && (
                <div className={classes.button}>
                    <Button
                        href={`${!isHidden ? '#rooms' : ''}`}
                        onClick={() => setIsHidden(!isHidden)}
                        variant="outline"
                        className={classes.buttonShowMore}
                    >
                        <span>{isHidden ? 'Развернуть все номера' : 'Свернуть номера'}</span>
                        <span className={classNames( !isHidden ? classes.buttonIconUp : '', classes.buttonIcon)}>
                            <IconArrowBottom />
                        </span>
                    </Button>
                </div>
            )}
        </section>
    );
};
